<div
  class="row"
  trackImpression="contentblock-impression"
  [trackImpressionInfo]="rendering"
  [trackImpressionContext]="context"
>
  @if (reviewsAndStats$ | async; as reviewsAndStats) {
    <wl-review-score
      class="col-12"
      [rendering]="rendering"
      [stats]="reviewsAndStats"
      type="overview"
    ></wl-review-score>
  }
</div>

<div class="row">
  <!-- semi-masonry display -->
  <div class="col-lg-6 d-none d-lg-block">
    @for (review of leftReviews; track trackReview($index, review)) {
      <wl-review [review]="review" [rendering]="rendering"></wl-review>
    }
  </div>
  <div class="col-lg-6 d-none d-lg-block">
    @for (review of rightReviews; track trackReview($index, review)) {
      <wl-review [review]="review" [rendering]="rendering"></wl-review>
    }
  </div>

  <!-- mobile display -->
  <div class="col-12 d-lg-none">
    @for (review of reviews; track trackReview($index, review)) {
      <wl-review [review]="review" [rendering]="rendering"></wl-review>
    }
  </div>
</div>

<div class="row justify-content-center mt-4">
  <div class="col-12 text-center">
    <button
      class="btn btn-primary"
      (click)="loadMoreReviews()"
      wlAutomationId="show-more-reviews-button"
      *scText="rendering?.fields?.ButtonText"
    ></button>
  </div>
</div>
